var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.topBanner.img_url && _vm.loaded),expression:"topBanner.img_url && loaded"}],staticClass:"top-banner"},[_c('router-link',{attrs:{"to":_vm.topBanner.pc_url}},[_c('img',{attrs:{"src":_vm.topBanner.img_url,"alt":"顶部广告"}})])],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3d2641da","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/nav/TopBanner.vue
// module id = null
// module chunks = 